import store from '@/store';

const dataFinder = (storeKey, id) => {
  return store.getState()[storeKey][id];
};

export default dataFinder;
